import React from "react";

const EmailAlertsTable = ({ openFormForEdit }) => {
  // Mock data matching the Director table fields
  const mockData = [
    {
      id: 801,
      name: "Alerts Manager A",
      email: "managerA@email-alerts.com",
      companyType: "Alerts",
      dobScrapeType: "Type A",
      companyName: "Email Alerts Inc",
      password: "•••••",
    },
    {
      id: 802,
      name: "Alerts Manager B",
      email: "managerB@email-alerts.com",
      companyType: "Alerts",
      dobScrapeType: "Type B",
      companyName: "Notify Solutions LLC",
      password: "•••••",
    },
  ];

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Email Alerts Table</h2>

      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Company Type</th>
            <th className="px-4 py-2 text-left">DOB Scrape Type</th>
            <th className="px-4 py-2 text-left">Company Name</th>
            <th className="px-4 py-2 text-left">Password</th>
          </tr>
        </thead>
        <tbody>
          {mockData.map((row) => (
            <tr
              key={row.id}
              className="border-b hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                if (openFormForEdit) {
                  openFormForEdit(row);
                }
              }}
            >
              <td className="px-4 py-2 text-blue-600 underline">
                {row.name}
              </td>
              <td className="px-4 py-2">{row.email}</td>
              <td className="px-4 py-2">{row.companyType}</td>
              <td className="px-4 py-2">{row.dobScrapeType}</td>
              <td className="px-4 py-2">{row.companyName}</td>
              <td className="px-4 py-2">{row.password}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmailAlertsTable;
